import {store} from '../../Redux/store';
import { getUserIdFromJid } from '../Utility';
import { addGroupsMemberParticipantsList } from '../../Redux/feature/groupsMemberParticipantsListSlice';
import { addGroupMembersData } from "../../Redux/feature/groupMembersDataSlice";
import { useSelector } from 'react-redux';
/**
// export const setGroupParticipants = (res) => {
//     store.dispatch(GroupsMemberListAction(res));
// }
*/
export const setGroupParticipants = (res) => {
    store.dispatch(addGroupMembersData(res));
}

export const setGroupParticipantsByGroupId = (groupId, participantsList) => {
    store.dispatch(addGroupsMemberParticipantsList({
        "groupId": groupId,
        "participantsList": participantsList
    }))
}

/**
 * Get the group data from groups list
 * @param {*} groupId
 */
export const getGroupData = (groupId = "") => {
    const { data: groupData } = store.getState().groupsData;
    return groupData.find((obj) => groupId.indexOf(obj.groupId) > -1);
}

/**
 * Check Given user exist in group or not
 */
export const isUserExistInGroup = (userId, groupUsers) => {
    if(!userId || (groupUsers && !Array.isArray(groupUsers))) return false;

    if(!groupUsers){
        const { groupsMemberListData: { data: { participants } = {} } = {} } = store.getState();
        if(!participants) return false;
        groupUsers = participants;
    }
    return groupUsers.some(user => user.userId === userId);
}

/**
 * Check Given user exist in group or not
 */
 export const getUserFromGroup = (userId, groupUsers) => {
    const globalState = useSelector((state) => state);
    if (!userId || (groupUsers && !Array.isArray(groupUsers))) return false;
    userId = getUserIdFromJid(userId);
    if (!groupUsers) {
      const { groupsMemberListData: { data: { participants } = {} } = {} } = globalState;
      if (!participants) return false;
      groupUsers = participants;
    }
    return groupUsers.find((user) => user.userId === userId);
  };
